// Marka logosu (tam lockup: rozet + "PAK"). Görsel public/pak-logo.svg'den gelir;
// vektörel olduğu için her boyutta nettir. Boyut className ile ayarlanabilir
// (varsayılan header yüksekliği ~36px).
export const PakLogo = ({ className = "" }) => {
  return (
    <a href="/" className={`inline-flex items-center ${className}`} data-testid="pak-logo">
      <img
        src={`${process.env.PUBLIC_URL || ""}/pak-logo.svg`}
        alt="PAK"
        className="h-9 w-auto"
        draggable="false"
      />
    </a>
  );
};

export default PakLogo;
